import { render, staticRenderFns } from "./AddressRentList.vue?vue&type=template&id=df467030&"
import script from "./AddressRentList.vue?vue&type=script&lang=js&"
export * from "./AddressRentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports